const useOrdinal = (currentLanguage) => {
  const getOrdinal = (num, isDay = true, isExtendedDate = false) => {
    if (currentLanguage === "es") {
      return isExtendedDate
        ? `${num} ${isDay ? "día" : "mes(es)"}`
        : `${isDay ? "día" : "mes"} ${num}`;
    }

    let suffix = "th";
    if (num % 10 === 1 && num !== 11) suffix = "st";
    else if (num % 10 === 2 && num !== 12) suffix = "nd";
    else if (num % 10 === 3 && num !== 13) suffix = "rd";
    return `${num}${isExtendedDate ? "" : suffix} ${
      isDay ? "day" : isExtendedDate ? "month(s)" : "month"
    }`;
  };

  const getMonthWord = (monthNumber) => {
    const monthNames = [
      currentLanguage === "en" ? "January" : "enero",
      currentLanguage === "en" ? "February" : "febrero",
      currentLanguage === "en" ? "March" : "marzo",
      currentLanguage === "en" ? "April" : "abril",
      currentLanguage === "en" ? "May" : "mayo",
      currentLanguage === "en" ? "June" : "junio",
      currentLanguage === "en" ? "July" : "julio",
      currentLanguage === "en" ? "August" : "agosto",
      currentLanguage === "en" ? "September" : "septiembre",
      currentLanguage === "en" ? "October" : "octubre",
      currentLanguage === "en" ? "November" : "noviembre",
      currentLanguage === "en" ? "December" : "diciembre",
    ];

    return monthNames[monthNumber - 1];
  };

  const dayData = Array.from({ length: 31 }, (_, i) => {
    const day = i + 1;
    return {
      text: getOrdinal(day),
      value: day,
    };
  });

  const monthData = Array.from({ length: 12 }, (_, i) => {
    const month = i + 1;
    return {
      text: getOrdinal(month, false),
      value: month,
    };
  });

  const monthlyWordData = Array.from({ length: 12 }, (_, i) => {
    const month = i + 1;
    return {
      text: getMonthWord(month),
      value: month,
    };
  });

  const monthDataForExtendedDate = Array.from({ length: 12 }, (_, i) => {
    const month = i + 1;
    return {
      text: getOrdinal(month, false, true),
      value: month,
    };
  });

  const yearData = [
    { text: currentLanguage === "en" ? "Fiscal Year" : "Año Fiscal", value: 1 },
    {
      text: currentLanguage === "en" ? "Calendar Year" : "Año Calendario",
      value: 0,
    },
  ];

  const dayNumberData = Array.from({ length: 31 }, (_, i) => {
    const day = i + 1;
    return {
      text: day,
      value: day,
    };
  });

  return {
    dayData,
    monthData,
    monthDataForExtendedDate,
    yearData,
    dayNumberData,
    monthlyWordData,
    getMonthWord,
  };
};

export default useOrdinal;
